// Отключаем все возможные скрипты для страницы с большой посещаемостью (Канни Уэст)
const useEasyLoading = () => {
  const { easyLoadingPaths } = useRuntimeConfig().public
  const { href: fullPath } = useRequestURL()

  const easyLoading =
    typeof easyLoadingPaths === 'string' ? easyLoadingPaths.split(' ') : []

  const needEasyLoading = computed(() => {
    return easyLoading.includes(fullPath)
  })

  return {
    needEasyLoading,
  }
}

export { useEasyLoading }
